var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item){return _c('div',{key:item.id},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.parse(item).html_code)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }